export function getLocalTime() {
  return new Date().toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getLocalDate() {
  const date = new Date().toLocaleDateString('pt-BR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });

  return date.charAt(0).toUpperCase() + date.slice(1);
}

/**
 * Copia um texto para a área de transferência.
 * Usa a Clipboard API quando disponível (contexto seguro/HTTPS) e cai num
 * fallback com elemento temporário no DOM para navegadores/contextos antigos
 * que não expõem `navigator.clipboard`.
 */
export function copyToClipboard(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text);
    return;
  }

  const input = document.createElement('textarea');
  input.value = text;
  input.setAttribute('readonly', '');
  input.style.position = 'absolute';
  input.style.left = '-9999px';
  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);
}
